import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Carousel } from '../Carousel';
import { useBannerItems } from './hooks/useBannerItems';
import styles from './ProductBanners.module.css';
export const SimpleBanners = ({ title, banners, context, autoPlay = true, interval = 5000, className, 'data-testid': dataTestId, }) => {
    const carouselItems = useBannerItems({
        banners,
        domain: context.domain,
        autoPlay,
    });
    if (!carouselItems?.length) {
        return null;
    }
    return (_jsxs("div", { className: `${styles.productBanners} ${className || ''}`, "data-testid": dataTestId, children: [title && _jsx("h2", { className: styles.productBannersTitle, children: title }), _jsx(Carousel, { items: carouselItems, autoPlay: autoPlay, interval: interval, "data-testid": `${dataTestId}-carousel` })] }));
};
